export * from "@fleet/export";
export * from "./todo-adapter";
export * from "./mail-adapter";

import { browserDelivery, exportDataset, type ExportDataset } from "@fleet/export";

export function downloadBlob(filename: string, blob: Blob): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.rel = "noopener noreferrer";
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export function exportDatasetAsCsv(dataset: ExportDataset, filename?: string): Promise<void> {
  return exportDataset(dataset, "csv", browserDelivery, filename);
}
